import { Routes, Route, useNavigate, useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';

import AppLayout from './components/user/layouts/applayout';
import { AppLayout as AdminLayout } from './components/admin/layouts/applayout';
import { adminRoutes, appRoutes, authRoutes } from './routes/routes';
import AuthGuard from './middleware/AuthGuard';
import UnProtectedRoutes from './middleware/UnProtectedRoutes';
import { storeStateType } from './redux/store';
import Loader from './components/common/Loader';
import { history } from './constants';

function App() {
  const isLoading = useSelector((state: storeStateType) => state.auth.loading);

  history.history = useNavigate();
  return (
    <div className='App'>
      <Routes>
        <Route element={<AppLayout />}>
          {appRoutes.map((route, index: number) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <UnProtectedRoutes
                    component={isLoading ? <Loader /> : <route.element />}
                  />
                }
              />
            );
          })}
          {authRoutes.map((route, index: number) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <AuthGuard
                    component={isLoading ? <Loader /> : <route.element />}
                  />
                }
              />
            );
          })}
        </Route>
        <Route
          path='/admin'
          element={<AuthGuard component={<AdminLayout />} />}
        >
          {adminRoutes.map((route, index: number) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <AuthGuard
                    component={isLoading ? <Loader /> : <route.element />}
                  />
                }
              />
            );
          })}
        </Route>
        <Route path='B4Tax.apk' />
      </Routes>
      <ToastContainer position='top-right' draggable theme='dark' />
    </div>
  );
}

export default App;
